import type { Interaction } from './protocol';
import type { AssetCache, AssetHandle } from './asset-cache';

interface Loaded { assetId: string; dead: boolean; handle?: AssetHandle; error: string }
export class InteractionAssets {
  private entries = new Map<string, Loaded>();
  constructor(private cache: AssetCache) {}
  sync(items: readonly Interaction[]): void {
    for (const [id, entry] of this.entries) if (!items.some(i => i.id === id && i.assetId === entry.assetId && i.phase !== 'invited')) { entry.dead = true; entry.handle?.release(); this.entries.delete(id); }
    for (const i of items) {
      if (i.phase === 'invited' || i.assetId === 'builtin_sit_v1' || i.assetId === 'builtin_pair_wave_v1' || this.entries.has(i.id)) continue;
      const entry: Loaded = { assetId: i.assetId, dead: false, error: '' }; this.entries.set(i.id, entry);
      void this.cache.acquire(i.assetId).then(handle => {
        if (entry.dead) { handle.release(); return; }
        const bundle = handle.template.interaction;
        if (!bundle || bundle.spec.kind !== i.kind || bundle.clips.length !== i.roles.length || JSON.stringify(bundle.spec.playback) !== JSON.stringify(i.playback)) { handle.release(); entry.error = 'Interaction contract mismatch'; return; }
        entry.handle = handle;
      }).catch(error => { if (!entry.dead) entry.error = error instanceof Error ? error.message : 'Interaction unavailable'; });
    }
  }
  readiness(i: Interaction): 'loading' | 'ready' | 'failed' {
    if (i.assetId === 'builtin_sit_v1' || i.assetId === 'builtin_pair_wave_v1') return 'ready';
    const entry = this.entries.get(i.id); return entry?.error ? 'failed' : entry?.handle ? 'ready' : 'loading';
  }
  bundle(id: string) { return this.entries.get(id)?.handle?.template.interaction; }
  reset(): void { for (const e of this.entries.values()) { e.dead = true; e.handle?.release(); } this.entries.clear(); }
  get size(): number { return this.entries.size; }
}
